"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTmp = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const lodash_1 = require("lodash");
const prop_types_1 = __importDefault(require("prop-types"));
const ToolTipComponent = (props) => {
    return (react_1.default.createElement(core_1.Tooltip, { title: props.title, placement: props.placement || 'top', className: `oneframe-tooltip`, "aria-label": "add " },
        react_1.default.createElement("span", null, props.children)));
};
ToolTipComponent.propTypes = {
    children: prop_types_1.default.element.isRequired,
    title: prop_types_1.default.node.isRequired,
    parentClass: prop_types_1.default.string,
    placement: prop_types_1.default.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top',
    ]),
};
exports.TooltipTmp = ToolTipComponent;
exports.default = react_1.default.memo(ToolTipComponent, (p, n) => lodash_1.isEqual(p.title, n.title) && lodash_1.isEqual(p.placement, n.placement));
